module.exports = __webpack_public_path__ + "static/media/01-1-mobile.882e900a.webp";